import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicTable, EmptyState, BaasicButton, TableFilter } from 'core/components';
import EmptyIcon from 'themes/assets/img/building-modern.svg';
import { ApplicationListLayout, Content, PageNavigation } from 'core/layouts';
import { isSome } from 'core/utils';

function DiagnosisCodeListTemplate({ diagnosisCodeListViewStore }) {
    const {
        tableLoading,
        tableStore,
        queryUtility,
        authorization,
        routes,
    } = diagnosisCodeListViewStore;

    return (
        <ApplicationListLayout store={diagnosisCodeListViewStore}>
            <PageNavigation>
            <BaasicButton authorized={authorization ? authorization.create : true} className="btn btn--base btn--primary" label={'LIST_LAYOUT.CREATE_BUTTON'} onClick={() => routes.create()}></BaasicButton>
            </PageNavigation>
            <Content emptyRenderer={renderEmpty()} >
                <TableFilter queryUtility={queryUtility}/>
                <div className='u-mar--bottom--sml'>
                </div>
                <div className="card--table">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                        authorization={authorization}
                        actionsComponent={renderActions}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    )
}

function renderEmpty() {
    return <EmptyState image={EmptyIcon} title='DIAGNOSIS_CODE.LIST.EMPTY_STATE.TITLE' description='DIAGNOSIS_CODE.LIST.EMPTY_STATE.DESCRIPTION' />
}

DiagnosisCodeListTemplate.propTypes = {
    diagnosisCodeListViewStore: PropTypes.object
};

function renderActions({item, actions, authorization}){
    if (!isSome(actions)) return null;

    const { onEdit, onDelete} = actions;
    if (!isSome(onEdit) && !isSome(onDelete));

    return (
        <td className="table__body--data right">
            <div className="table__icons">
                {isSome(onEdit) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.read : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--edit u-icon--sml'
                        label='DIAGNOSIS_CODE.LIST.BUTTON.EDIT'
                        onlyIcon={true}
                        onClick={() => onEdit(item)}>
                    </BaasicButton>
                ) : null}  
                {isSome(onDelete) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon is-delete"
                        icon='u-icon u-icon--delete u-icon--sml'
                        label='DIAGNOSIS_CODE.LIST.BUTTON.DELETE'
                        onlyIcon={true}
                        onClick={() => onDelete(item)}>
                    </BaasicButton>
                ) : null}
            </div>
        </td>
    );
}

renderActions.propTypes = {
    item: PropTypes.any,
    actions: PropTypes.any,
    authorization: PropTypes.any
};

export default defaultTemplate(DiagnosisCodeListTemplate);
